import { render, staticRenderFns } from "./MaterialSnackbar.vue?vue&type=template&id=e3b77ab2"
import script from "./MaterialSnackbar.vue?vue&type=script&lang=js"
export * from "./MaterialSnackbar.vue?vue&type=script&lang=js"
import style0 from "./MaterialSnackbar.vue?vue&type=style&index=0&id=e3b77ab2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports